import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../../../common/hooks/useAuth';
import { PermissionConstant } from '../../utils/permission';

interface CoursePermissionGuardProps {
  children: React.ReactNode;
}

/**
 * CoursePermissionGuard ensures users have dp.twin.course.library.view permission
 * for course-related routes. Redirects to iso-file-management if permission is missing.
 */
const CoursePermissionGuard: React.FC<CoursePermissionGuardProps> = ({ children }) => {
  const navigate = useNavigate();
  const { hasPermission, isPermissionsLoading } = useAuth();

  useEffect(() => {
    // Wait for permissions to load
    if (isPermissionsLoading()) {
      return;
    }

    // Check for course library view permission
    const hasCoursePermission = hasPermission(PermissionConstant.COURSE_LIBRARY_VIEW);
    
    if (!hasCoursePermission) {
      // User doesn't have permission, redirect to iso file management
      navigate('/academy/iso-file-management', { replace: true });
    }
  }, [isPermissionsLoading(), hasPermission(PermissionConstant.COURSE_LIBRARY_VIEW), navigate]);

  // Render children if permissions are loading or user has permission
  return <>{children}</>;
};

export default CoursePermissionGuard;